// 图片配置文件
// 用于管理全局图片显示基础地址

// 环境配置
const isDevelopment = process.env.NODE_ENV === 'development';
const isProduction = process.env.NODE_ENV === 'production';

// 图片基础URL配置
const IMAGE_BASE_URLS = {
  development: process.env.REACT_APP_IMAGE_BASE_URL || 'https://www.lsxlbg.com',
  production: process.env.REACT_APP_IMAGE_BASE_URL || 'https://www.lsxlbg.com',
  test: process.env.REACT_APP_IMAGE_BASE_URL || 'https://www.lsxlbg.com'
};

// 获取当前环境的图片基础URL
export const getImageBaseUrl = () => {
  if (isDevelopment) {
    return IMAGE_BASE_URLS.development;
  }
  if (isProduction) {
    return IMAGE_BASE_URLS.production;
  }
  return IMAGE_BASE_URLS.development;
};

// 图片URL处理工具函数
export const getImageUrl = (imagePath) => {
  // 如果图片路径为空或未定义，返回默认占位图
  if (!imagePath) {
    return '/images/placeholder.jpg';
  }
  
  // 如果已经是完整的URL（包含http或https），直接返回
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // 如果是相对路径，拼接基础URL
  const baseUrl = getImageBaseUrl();
  const cleanPath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
  const finalUrl = `${baseUrl}${cleanPath}`;
  

  return finalUrl;
};

// 批量处理图片URL的工具函数
export const processImageUrls = (data, imageFields = []) => {
  if (!data) return data;
  
  // 如果是数组，递归处理每个元素
  if (Array.isArray(data)) {
    return data.map(item => processImageUrls(item, imageFields));
  }
  
  // 如果是对象，处理指定的图片字段
  if (typeof data === 'object') {
    const processedData = { ...data };
    
    // 处理指定的图片字段
    imageFields.forEach(field => {
      if (processedData[field]) {
        processedData[field] = getImageUrl(processedData[field]);
      }
    });
    
    // 处理常见的图片字段名
    const commonImageFields = [
      'image', 'imageUrl', 'image_url',
      'cover_image', 'coverImage',
      'main_image_url', 'mainImageUrl', 'main_image',
      'thumbnail', 'thumbnailUrl', 'thumbnail_url',
      'featuredImage', 'featured_image',
      'avatar', 'avatarUrl', 'avatar_url',
      'photo', 'photoUrl', 'photo_url',
      'picture', 'pictureUrl', 'picture_url',
      'banner', 'bannerUrl', 'banner_url',
      'background', 'backgroundUrl', 'background_url'
    ];
    
    commonImageFields.forEach(field => {
      if (processedData[field] && typeof processedData[field] === 'string') {
        processedData[field] = getImageUrl(processedData[field]);
      }
    });
    
    // 处理图片数组字段
    const imageArrayFields = [
      'images', 'gallery', 'gallery_images',
      'photos', 'pictures', 'thumbnails'
    ];
    
    imageArrayFields.forEach(field => {
      if (Array.isArray(processedData[field])) {
        processedData[field] = processedData[field].map(img => 
          typeof img === 'string' ? getImageUrl(img) : img
        );
      }
    });
    
    // 递归处理嵌套的对象和数组
    Object.keys(processedData).forEach(key => {
      if (processedData[key] && typeof processedData[key] === 'object') {
        processedData[key] = processImageUrls(processedData[key], imageFields);
      }
    });
    
    return processedData;
  }
  
  return data;
};

// 导出配置常量
export const IMAGE_CONFIG = {
  BASE_URLS: IMAGE_BASE_URLS,
  CURRENT_BASE_URL: getImageBaseUrl(),
  PLACEHOLDER_IMAGE: '/images/placeholder.jpg'
};

// 默认导出
const imageConfig = {
  getImageBaseUrl,
  getImageUrl,
  processImageUrls,
  IMAGE_CONFIG
};

export default imageConfig;